import LoadPanel from 'app/components/LoadPanel';
import WrapContent from 'app/components/WrapContent/WrapContent';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import useDictionary from 'hooks/useDictionary';
import React, { useContext } from 'react';
import '../HomePage/styles.scss';
import { LayoutContext } from 'app/components/Layout';
import { programContant } from 'constant/router';
import { useSetRecoilState } from 'recoil';
import { tabIndexTodayReport } from 'store/atom-state/today-report-atom';

const AlarmNotice = React.lazy(() => import('../AlarmNotice'));
const M2087DWeb = React.lazy(() => import('../M2087_D_Web'));
const TabReorderPoint = React.lazy(() => import('./TabReorderPoint'));
const TabReceive = React.lazy(() => import('./TabReceive'));
const TabShippingStatus = React.lazy(() => import('./TabShippingStatus'));
const TabInventory = React.lazy(() => import('./TabInventory'));
const TabOrderAndPicking = React.lazy(() => import('./TabOrderAndPicking'));
const TabTrackingDelivery = React.lazy(() => import('./TabTrackingDelivery'));

export function HomePage() {
  const { t } = useDictionary({});
  const layOutContext: any = useContext(LayoutContext);
  const setTabIndexTodayReport = useSetRecoilState(tabIndexTodayReport);

  return (
    <>
      <WrapContent>
        <React.Suspense fallback={<LoadPanel visible={true} />}>
          <div
            className="title-page"
            style={{ marginTop: 0, lineHeight: '25px' }}
          >
            {t('Today Report')}
          </div>
          <div className="home-page-content">
            <TabPanel
              loop
              animationEnabled
              swipeEnabled={false}
              deferRendering={true}
              repaintChangesOnly
              showNavButtons
              scrollingEnabled
              scrollByContent
              defaultSelectedIndex={0}
              className="home-tab-panel-custom"
              onSelectedIndexChange={tabIdx => setTabIndexTodayReport(tabIdx)}
            >
              <Item title={t('Notification')} key={`tab-notification`}>
                <AlarmNotice />
              </Item>
              <Item
                title={t('Reorder Point (ROP) For Order')}
                key={`tab-reorder-point`}
              >
                <TabReorderPoint />
              </Item>
              <Item
                title={t('Sales Performance by Store')}
                key={`tab-sales-performance-by-store`}
                visible={layOutContext?.fullMenu?.some?.(
                  o => o.programId === programContant.m2087_D,
                )}
              >
                <M2087DWeb />
              </Item>
              <Item title={t('Receive')} key={`tab-receive`}>
                <TabReceive />
              </Item>
              <Item title={t('Shipping')} key={`tab-shipping`}>
                <TabShippingStatus />
              </Item>
              <Item title={t('Inventory')} key={`tab-inventory`}>
                <TabInventory />
              </Item>
              <Item title={t('Order & Picking')} key={`tab-order-picking`}>
                <TabOrderAndPicking />
              </Item>
              <Item
                title={t('Tracking Delivery')}
                key={`tab-tracking-delivery`}
              >
                <TabTrackingDelivery />
              </Item>
            </TabPanel>
          </div>
        </React.Suspense>
      </WrapContent>
    </>
  );
}
